export default "__VITE_ASSET__234d3199__"